import { actions } from './requirement/actions'
import { getters } from './requirement/getters'
import { state } from './requirement/state'
import { mutations } from './requirement/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
